import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=6e6522de&"
import script from "./ViewItem.vue?vue&type=script&lang=js&"
export * from "./ViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e6522de')) {
      api.createRecord('6e6522de', component.options)
    } else {
      api.reload('6e6522de', component.options)
    }
    module.hot.accept("./ViewItem.vue?vue&type=template&id=6e6522de&", function () {
      api.rerender('6e6522de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/invoices/ViewItem.vue"
export default component.exports